import { Storage } from "@/services/Storage";
import axios from "axios";
import router from "@/router";
import TimeManager from "@/services/TimeManager";
import store from "@/store";
import connectivityMonitor from '@/services/connectivityMonitor';

export default {
    name: 'billing',
    state: {
        daysToExpire: 30
    },
    getters: {
        getDaysToExpire: (state) => state.daysToExpire,
    },
    mutations: {
        setDaysToExpire: (state, data) => state.daysToExpire = data,
    },
    actions: {
        getExpiryDateByCustomerID: async (context) => {
            let storeID = await Storage.getRegistrationDetails();
            if (!storeID) return;

            // Check if online
            const isOnline = connectivityMonitor.getStatus();

            if (!isOnline) {

                const cachedExpiry = await Storage.getStoreExpiry();

                if (cachedExpiry) {
                    let days = TimeManager.getDateDiff(TimeManager.getNow(), cachedExpiry);
                    context.commit(`setDaysToExpire`, days);
                    //console.log('[Billing] Cached expiry:', cachedExpiry, 'Days to expire:', days);
                    if (days <= 0) {
                        return router.push({ name: 'validation' });
                    }
                    return;
                } else {
                    console.warn('[Billing] No cached expiry date available. Allowing login.');
                    // No cached expiry - allow login (benefit of the doubt when offline)
                    return;
                }
            }

            // Online: Fetch from server and cache the result
            return axios.get(subscriptionApi + `adminCustomerPanel/getExpiryDate?customer=` + storeID.id)
                .then(async ({ data }) => {
                    // Store expiry date for offline use
                    await Storage.setStoreExpiry(data);
                    //console.log('[Billing] Stored expiry date:', data);

                    let days = TimeManager.getDateDiff(TimeManager.getNow(), data);
                    context.commit(`setDaysToExpire`, days);
                    if (days <= 0) {
                        return router.push({ name: 'validation' });
                    }
                }).catch(async (err) => {
                    // Network error: Fallback to cached expiry
                    console.warn('[Billing] Failed to fetch expiry from server, using cache:', err.message);
                    const cachedExpiry = await Storage.getStoreExpiry();

                    if (cachedExpiry) {
                        let days = TimeManager.getDateDiff(TimeManager.getNow(), cachedExpiry);
                        context.commit(`setDaysToExpire`, days);
                        if (days <= 0) {
                            return router.push({ name: 'validation' });
                        }
                        return;
                    } else {
                        // No cache and network error - propagate error
                        errorHandler.tomcatError(err);
                        router.push({ name: 'poslogin' });
                        throw err;
                    }
                })
        },

        getCustomerBalance: async () => {
            let customerID = await Storage.getCurrentStoreID();
            if (!customerID) return;
            return axios.get(subscriptionApi + `adminCustomerPanel/getBalance?customer=` + customerID)
                .then(({ data }) => data).catch(err => errorHandler.tomcatError(err))
        },

        hasOverdueCount: async (context) => {
            let customerID = await Storage.getCurrentStoreID();
            if (!customerID) return;
            return axios.get(subscriptionApi + `adminCustomerPanel/hasOverdueCount?customer=` + customerID)
                .then(({ data }) => data).catch(err => errorHandler.tomcatError(err))
        },

        getDueInvoices: async () => {
            let storeID = await Storage.getRegistrationDetails();
            if (!storeID) return;
            return axios.get(subscriptionApi + `adminCustomerPanel/getDueInvoice?customer=` + storeID.id)
                .then(({ data }) => data).catch(err => errorHandler.tomcatError(err))
        },

        getActiveStores: async () => {
            let customerID = await Storage.getCurrentStoreID();
            if (!customerID) return;
            return axios.get(subscriptionApi + `adminCustomerPanel/getActiveStores?customer=` + customerID)
                .then(({ data }) => data).catch(err => errorHandler.tomcatError(err))
        },

        getCustomerQuotes: async (context) => {
            let customerID = await Storage.getCurrentStoreID();
            if (!customerID) return;
            return axios.get(subscriptionApi + `adminCustomerPanel/getQuotes?customer=` + customerID)
                .then(({ data }) => data).catch(err => errorHandler.tomcatError(err))
        },
        makeKazangLicensePayment: async (context, payload) => {
            let invoiceReference = payload.invoiceReference;
            return axios.post(kazangSubscriptionApi + `paymentGateWay/makeAndProcessPayment`, payload, { timeout: 1000 * 2 * 60 })
                .then(() => {
                    return axios.get(subscriptionApiGET, {
                        params: {
                            route: `paymentCompleted/kazangProcess/${invoiceReference}`
                        }
                    }).then(() => context.dispatch(`getExpiryDateByCustomerID`)).catch(err => {
                        throw new Error(err.response)
                    })
                }).catch(err => errorHandler.tomcatError(err));

        },

        makeVCDLicensePayment: async (context, invoiceReference) => {
            return axios.get(subscriptionApi + `paymentCompleted/kazangProcessVCD/${invoiceReference}`)
                .then(() => context.dispatch(`getExpiryDateByCustomerID`)).catch(err => errorHandler.tomcatError(err));
        },

    }
}
